import { render, staticRenderFns } from "./LiquidacionInyCo.vue?vue&type=template&id=4535f538"
import script from "./LiquidacionInyCo.vue?vue&type=script&lang=js"
export * from "./LiquidacionInyCo.vue?vue&type=script&lang=js"
import style0 from "./LiquidacionInyCo.vue?vue&type=style&index=0&id=4535f538&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports